<template>
  <el-dialog :visible="visible" destroy-on-close title="批量打印" @close="handleCancel">
    <div class="batch-search-dialog">
      <el-input type="textarea" placeholder="请输入批次包号(换行输入，每行一条批次包号,最多 200 条)" v-model="keyword" @input="changeInput"
        style="height:200px;" ref="batchInput">
      </el-input>
      <div class="submit-btn">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleOk">搜索</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { listPkgDetail } from '@/apis/outStock'
export default {
  name: 'batchSearchDialog',
  props: {
    max: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      visible: false,
      keyword: "",
      key: ""
    }
  },
  methods: {
    open(obj) {
      this.key = obj.key;
      this.keyword = (obj.data && obj.data.join("\n")) || "";
      this.visible = !this.visible;
      setTimeout(_ => {
        this.$refs['batchInput'].focus()
      }, 100)
    },
    changeInput() {
      this.keyword = this.keyword
        .split(/\n/)
        .splice(0, this.max)
        .join("\n");
    },
    focusIpt() {
      this.$refs['batchInput'].focus()
    },
    async handleOk() {
      if (!this.keyword) {
        this.$message.warning("请输入！");
        return
      }
      const params = this.keyword.trim().split(/\n/).map(i => i.trim()).filter(i => i).map(i => {
        return {
          pkgCode: i
        }
      });
      this.$wmsPrint.print().templatePrintByPkg(params);
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
      this.$emit('batchClose')
    }
  }
}
</script>
<style lang="less">
.batch-search-dialog {
  .el-textarea__inner {
    height: 200px;

  }

  .submit-btn {
    padding-top: 20px;
    text-align: right;
  }
}
</style>
